import { Link } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#050814]/90 backdrop-blur border-b border-yellow-400/20">
      <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">

        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-gradient-to-r from-blue-400 to-yellow-300"></span>
          <span className="font-bold">JEEVITHA R</span>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex gap-6 text-sm text-gray-400">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/skills">Skills</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/experience">Experience</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        {/* Mobile Button */}
        <button onClick={() => setOpen(!open)} className="md:hidden text-yellow-300">
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-[#0b1020] border-t border-white/10 px-6 py-4 space-y-3 text-gray-400">
          <Link onClick={() => setOpen(false)} to="/">Home</Link>
          <Link onClick={() => setOpen(false)} to="/about">About</Link>
          <Link onClick={() => setOpen(false)} to="/skills">Skills</Link>
          <Link onClick={() => setOpen(false)} to="/projects">Projects</Link>
          <Link onClick={() => setOpen(false)} to="/experience">Experience</Link>
          <Link onClick={() => setOpen(false)} to="/contact">Contact</Link>
        </div>
      )}
    </header>
  );
}
